import { ElementDTOUnion, ElementTypeDTO, TextElementDTO } from '@/model';
import { isTextElementType } from '@/components';

export const getElementDisplayName = (element: ElementDTOUnion) => {
  const { name, elementType } = element;

  if (isTextElementType(elementType)) {
    return (element as TextElementDTO).textValue;
  }

  if (elementType === ElementTypeDTO.ANNOUNCEMENT) {
    return element.announcement?.name;
  }

  return name;
};

export const isElementResizable = (element: ElementDTOUnion) =>
  [
    ElementTypeDTO.ANNOUNCEMENT,
    ElementTypeDTO.CLOCK,
    ElementTypeDTO.TEXT_CONSTANT,
    ElementTypeDTO.TIME_COUNT_DOWN,
    ElementTypeDTO.STOP_NAME,
    ElementTypeDTO.STOP_DIRECTION_NAME,
    ElementTypeDTO.IMAGE_DISPLAY_NORMAL,
    ElementTypeDTO.PAGE_COUNTER,
  ].includes(element.elementType);
